import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {Redirect, Switch} from 'react-router-dom'
import * as auth from './redux/AuthRedux'
import {getRefreshToken, removeDataLogin} from './helpers'
import {useLocalStorage} from '../../utils'
import { revokeRefreshToken } from './apis'

export function Logout() {
  const [userRoot] = useLocalStorage<any>('persist:root', [])
  const dispatch = useDispatch()

  useEffect(() => {
    let data = {
      refreshToken: getRefreshToken(),
      userId: userRoot?.userId?.replaceAll('"', ''),
    }
    revokeRefreshToken(data)
    dispatch(auth.actions.logout())
    removeDataLogin()
    document.location.reload()
  }, [dispatch])

  return (
    <Switch>
      <Redirect to='/auth/login' />
    </Switch>
  )
}
